import FrozenAccountWarning from './FrozenAccountWarning';

export default FrozenAccountWarning;
